import { render, staticRenderFns } from "./PhoneNumber.vue?vue&type=template&id=6685c8c3&scoped=true"
import script from "./PhoneNumber.vue?vue&type=script&lang=js"
export * from "./PhoneNumber.vue?vue&type=script&lang=js"
import style0 from "./PhoneNumber.vue?vue&type=style&index=0&id=6685c8c3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6685c8c3",
  null
  
)

export default component.exports